export default {"src":"https://kroemtech.ch//_next/static/media/kroemtech_logo_white.74543f33.svg","height":92,"width":519,"blurWidth":0,"blurHeight":0};